import { render } from "./harvesterhci.io.management.cluster.vue?vue&type=template&id=580a2387&scoped=true"
import script from "./harvesterhci.io.management.cluster.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.management.cluster.vue?vue&type=script&lang=js"

import "./harvesterhci.io.management.cluster.vue?vue&type=style&index=0&id=580a2387&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580a2387"]])

export default __exports__